import { Routes } from "@angular/router";
import { AppRoutes, BUSINESS_UNIT } from "./constants";
import { AuthGuard } from "./guards/auth.guard";
import { RoleGuard } from "./guards/role.guard";
import { inject } from "@angular/core";
import { UserStore } from "./store/user.store";

export const routes: Routes = [
  {
    path: AppRoutes.LOGIN,
    loadComponent: () => import("./pages/login/login.component").then(m => m.LoginComponent),
  },
  {
    path: "",
    canActivate: [AuthGuard, RoleGuard],
    loadComponent: () => import("./components/main-layout/main-layout.component").then(m => m.MainLayoutComponent),
    children: [
      {
        path: "",
        redirectTo: (): string => {
          const userStore = inject(UserStore);
          const businessUnit = userStore.currentBusinessUnit();
          const userRoles = userStore.userRoles();

          // Check if user is a provider first
          if (userRoles.includes("provider")) {
            return AppRoutes.PROVIDERS;
          }

          // Then check business unit for other roles
          switch (businessUnit) {
            case BUSINESS_UNIT.YACHT:
              return AppRoutes.CHARTERS;
            case BUSINESS_UNIT.VILLA:
              return AppRoutes.VILLA_RESERVATIONS;
            default:
              return AppRoutes.PACKERS;
          }
        },
        pathMatch: "full",
      },
      {
        path: AppRoutes.CHARTERS,
        loadComponent: () => import("./pages/reservations/charters/charters.component").then(m => m.ChartersComponent),
      },
      {
        path: AppRoutes.VILLA_RESERVATIONS,
        loadComponent: () =>
          import("./pages/reservations/villa-reservations/villa-reservations.component").then(m => m.VillaReservationsComponent),
      },
      {
        path: AppRoutes.PACKERS,
        loadComponent: () => import("./pages/packers/packers.component").then(m => m.PackersComponent),
      },
      {
        path: AppRoutes.PROVIDERS,
        loadComponent: () => import("./pages/providers/providers.component").then(m => m.ProvidersComponent),
      },
      {
        path: AppRoutes.ASSETS,
        loadComponent: () => import("./pages/assets/assets.component").then(m => m.AssetsComponent),
      },
      {
        path: AppRoutes.CUSTOMERS,
        loadComponent: () => import("./pages/customers/customers.component").then(m => m.CustomersComponent),
      },
      {
        path: AppRoutes.ORDERS,
        loadComponent: () => import("./pages/orders/orders.component").then(m => m.OrdersComponent),
      },
      {
        path: AppRoutes.ZONES,
        loadComponent: () => import("./pages/zones/zones.component").then(m => m.ZonesComponent),
      },
      {
        path: AppRoutes.AGENCIES,
        loadComponent: () => import("./pages/agencies/agencies.component").then(m => m.AgenciesComponent),
      },
      {
        path: AppRoutes.STOREFRONT_CONFIG,
        loadComponent: () => import("./pages/storefront-config/storefront-config.component").then(m => m.StorefrontConfigComponent),
      },
      {
        path: AppRoutes.SETTINGS,
        loadComponent: () => import("./pages/settings/settings.component").then(m => m.SettingsComponent),
      },
    ],
  },
  {
    path: "not-found",
    loadComponent: () => import("./pages/not-found/not-found.component").then(m => m.NotFoundComponent),
  },
  {
    path: "**",
    redirectTo: "not-found",
  },
];
